<template>
  <div class="minwidth w100 mw100">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img :src="require('../../public/img/join/pic2.png')" class="positionabs" />
      <div style="color: #fff;font-size: 3rem;position: absolute;top: 8rem;left: 50%;transform: translate(-50%);">
        登录
      </div>
    </div>

    <div class="form-wrap">
      <div class="form-row">
        <div class="form-label">账号：</div>
        <input v-model.trim="form.account" class="form-input" type="text" placeholder="请输入账号" />
      </div>
      <div class="form-row">
        <div class="form-label">密码：</div>
        <input v-model="form.password" class="form-input" type="password" placeholder="请输入密码" />
      </div>

      <agreement v-model="agreed"></agreement>

      <div class="form-btn" @click="handleLogin">登录</div>
      <div class="form-link" @click="gotoRegister">注册 ></div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
import { login } from '../utils/auth'

export default {
  data() {
    return {
      agreed: false,
      form: {
        account: '',
        password: '',
      },
    }
  },

  methods: {
    handleLogin() {
      const { account, password } = this.form
      if (!account || !password) {
        this.$message.warning('请输入账号和密码')
        return
      }
      if (!this.agreed) {
        this.$message.warning('请先阅读并同意服务协议与用户隐私说明')
        return
      }
      const res = login({ account, password })
      if (!res.ok) {
        this.$message.error(res.message)
        return
      }
      this.$message.success(res.message)
      this.$router.push('/')
    },
    gotoRegister() {
      this.$router.push({ path: '/register' })
    },
  },
}
</script>

<style scoped>
.w100 {
  width: 100%;
}

.w60 {
  width: 60%;
}

.minwidth {
  min-width: 1000px;
}

.form-wrap {
  width: 28%;
  margin: 0 auto;
  padding: 2rem 0 3rem;
}

.form-row {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
}

.form-label {
  width: 22%;
  text-align: right;
  padding-right: 10px;
  box-sizing: border-box;
}

.form-input {
  width: 60%;
  display: block;
  height: 1.8rem;
  padding: 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-btn {
  width: 85%;
  margin: 1rem auto 0;
  text-align: center;
  background-color: #4571DB;
  height: 2.5rem;
  line-height: 2.5rem;
  border-radius: 1rem;
  color: #fff;
  cursor: pointer;
}

.form-btn:hover {
  opacity: 0.9;
}

.form-link {
  text-align: center;
  margin-top: 2rem;
  color: #888888;
  cursor: pointer;
}

.positionrel {
  position: relative;
  height: 320px;
  overflow: hidden;
}

.positionabs {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 1920px;
  -webkit-filter: contrast(50%);
  filter: contrast(50%);
}

@media screen and (max-width: 750px) {
  .minwidth {
    min-width: 0px;
  }

  .mw100 {
    width: 100vw;
  }

  .form-wrap {
    width: 88%;
  }

  .form-label {
    width: 28%;
  }

  .form-input {
    width: 68%;
  }

  .positionrel {
    position: relative;
    height: 179px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 780px;
  }
}
</style>
